<template>
  <div id="app">
    <InstagramFeed title="Lil' Spoonfuls" descripton="Serving healthy, vegetarian eats to our kiddo, one bite at a time." />
  </div>
</template>

<script>
import InstagramFeed from './components/InstagramFeed'

export default {
  name: 'App',
  components: {
    InstagramFeed
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
